import { render, staticRenderFns } from "./SortableItem.vue?vue&type=template&id=577fd358&scoped=true"
import script from "./SortableItem.ts?vue&type=script&lang=ts&external"
export * from "./SortableItem.ts?vue&type=script&lang=ts&external"
import style0 from "./SortableItem.vue?vue&type=style&index=0&id=577fd358&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577fd358",
  null
  
)

export default component.exports